const EnvSettings = {
	server:(process.env.NODE_ENV !== 'production')? 'http://18.159.225.119:3000/api':'/api'
}

export default EnvSettings;